import type { ExtendedBaggage, PassengerWithBaggage } from '../types';

const getSelectedBaggagePrice = (baggage: ExtendedBaggage[]) => {
  return Number(baggage.find(item => item.isSelected)?.price.amount) || 0;
};

const getTotalPrice = (passengers: PassengerWithBaggage[]) => {
  return passengers.reduce((sum, passenger) => {
    const totalPricesByFlights = passenger.flightsWithBaggages.map(flight =>
      getSelectedBaggagePrice(flight.availableBaggages),
    );

    const flightSum = totalPricesByFlights.reduce(
      (sum, flight) => sum + flight,
      0,
    );
    return sum + flightSum;
  }, 0);
};

const getBaggageMinPrice = (
  baggages: ExtendedBaggage[],
): string | undefined => {
  return baggages.reduce(
    (minAmountStr, currentItem) => {
      const currentAmount = Number.parseFloat(currentItem?.price?.amount);

      if (Number.isNaN(currentAmount)) {
        return minAmountStr;
      }

      const isNewMinimum =
        minAmountStr === undefined ||
        currentAmount < Number.parseFloat(minAmountStr);

      return isNewMinimum ? currentItem.price.amount : minAmountStr;
    },
    undefined as string | undefined,
  );
};

export const priceLib = {
  getSelectedBaggagePrice,
  getTotalPrice,
  getBaggageMinPrice,
};
